/* Rootgrow quantity recommendation.
   Reads custom.rootgrow_g per plant (via snippets/gl-rootgrow-data.liquid) and the
   live basket, works out the grams still needed after any rootgrow already in the
   basket, and rewrites every rootgrow add-on card ([data-gl-rg-card]) to offer the
   cheapest set of packs that covers it. Cards carry data-gl-rg-items for the add
   handlers in gl-addons.js and the cart add-ons section. */
(function () {
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  function data() {
    var packs = [], map = {};
    document.querySelectorAll('script[data-gl-rg]').forEach(function (s) {
      try {
        var d = JSON.parse(s.textContent);
        (d.packs || []).forEach(function (p) { if (!packs.some(function (q) { return q.variant === p.variant; })) packs.push(p); });
        Object.keys(d.map || {}).forEach(function (k) { map[k] = d.map[k]; });
      } catch (e) {}
    });
    packs.sort(function (a, b) { return b.grams - a.grams; });
    return { packs: packs, map: map };
  }

  function money(p) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(p, theme.moneyFormat);
    return '£' + (p / 100).toFixed(2);
  }
  function grams(g) { return g >= 1000 ? (Math.round(g / 100) / 10).toFixed(g % 1000 === 0 ? 0 : 1) + 'kg' : g + 'g'; }

  /* Cheapest combination of packs covering `need` grams; ties -> fewer packs. */
  function plan(need, packs) {
    if (!packs.length || need <= 0) return null;
    var best = null;
    var big = packs[0];
    var maxBig = Math.ceil(need / big.grams) + 1;
    function rec(i, counts, got, cost, n) {
      if (got >= need) {
        if (!best || cost < best.cost || (cost === best.cost && n < best.n)) best = { counts: counts.slice(), cost: cost, n: n, grams: got };
        return;
      }
      if (i >= packs.length) return;
      var p = packs[i];
      var max = i === 0 ? maxBig : Math.min(3, Math.ceil((need - got) / p.grams) + 1);
      for (var c = max; c >= 0; c--) {
        counts[i] = c;
        rec(i + 1, counts, got + c * p.grams, cost + c * p.price, n + c);
      }
      counts[i] = 0;
    }
    rec(0, packs.map(function () { return 0; }), 0, 0, 0);
    if (!best) return null;
    var items = [], parts = [];
    packs.forEach(function (p, i) {
      if (best.counts[i] > 0) { items.push({ id: p.variant, quantity: best.counts[i] }); parts.push(best.counts[i] + ' × ' + p.label); }
    });
    return { items: items, text: parts.join(' + '), cost: best.cost, grams: best.grams, n: best.n };
  }

  function apply(card, state) {
    var title = card.querySelector('[data-rg-title]') || card.querySelector('strong, .cart-addon__name');
    var blurb = card.querySelector('[data-rg-blurb]') || card.querySelector('small, .cart-addon__blurb');
    var price = card.querySelector('[data-rg-price]') || card.querySelector('.gl-upsell__buy b, .cart-addon__price');
    var btn = card.querySelector('[data-gl-upsell-add], [data-addon-add]');
    if (!state) { // no plant data: leave the plain single-pack card alone
      if (btn) btn.removeAttribute('data-gl-rg-items');
      card.hidden = false;
      return;
    }
    if (state.shortfall <= 0) { // enough rootgrow already in the basket
      if (!(btn && (btn.classList.contains('is-added') || btn.disabled))) card.hidden = true; // keep a just-added card visible as "Added"
      return;
    }
    var p = state.plan;
    if (!p) return;
    card.hidden = false;
    if (title) title.textContent = 'Rootgrow for your ' + state.plants + (state.plants === 1 ? ' plant' : ' plants');
    if (blurb) blurb.textContent = (state.have > 0 ? 'Still needs about ' : 'Needs about ') + grams(state.shortfall) + ': ' + p.text;
    if (price) price.textContent = money(p.cost);
    // picture and link follow the biggest pack in the plan (the card is built from the smallest)
    var lead = state.lead;
    if (lead && lead.image) {
      var img = card.querySelector('.gl-upsell__pic img, .cart-addon__media img');
      if (img && img.getAttribute('src') !== lead.image) { img.setAttribute('src', lead.image); img.removeAttribute('srcset'); }
      var link = card.querySelector('.gl-upsell__pic');
      if (link && lead.url) link.setAttribute('href', lead.url);
    }
    if (btn) {
      btn.setAttribute('data-gl-rg-items', JSON.stringify(p.items));
      if (!btn.classList.contains('is-added') && !btn.disabled) btn.innerHTML = '<i class="ph ph-plus" aria-hidden="true"></i> ' + (p.n > 1 ? 'Add all' : 'Add');
    }
  }

  var KIND_LABEL = { gel: 'for bare root', gran: 'granules' };

  function compute(cart, d) {
    var packByVariant = {};
    d.packs.forEach(function (p) { packByVariant[p.variant] = p; });
    var need = { gel: 0, gran: 0 }, have = { gel: 0, gran: 0 }, plants = 0, known = false;
    (cart.items || []).forEach(function (i) {
      var m = d.map[String(i.product_id)];
      if (m) {
        var g = typeof m === 'number' ? m : m.g, kind = (m && m.kind) || 'gran';
        need[kind] += g * i.quantity; plants += i.quantity; known = true;
      }
      var pk = packByVariant[i.variant_id];
      if (pk) have[pk.kind || 'gran'] += pk.grams * i.quantity;
    });
    if (!known) return null;
    // Each kind is planned with its own packs; if a kind has no packs in stock, fall back to the other kind's packs.
    var items = [], parts = [], cost = 0, shortfall = 0, got = 0, lead = null;
    ['gel', 'gran'].forEach(function (kind) {
      var sf = need[kind] - have[kind];
      if (sf <= 0) return;
      shortfall += sf;
      var packs = d.packs.filter(function (p) { return (p.kind || 'gran') === kind; });
      if (!packs.length) packs = d.packs;
      var p = plan(sf, packs);
      if (!p) return;
      items = items.concat(p.items); cost += p.cost; got += p.grams;
      parts.push(p.text + (need.gel > 0 && need.gran > 0 ? ' ' + KIND_LABEL[kind] : ''));
      if (!lead) lead = packs.filter(function (pk) { return p.items.some(function (i) { return i.id === pk.variant; }); })[0];
    });
    var totalHave = have.gel + have.gran;
    return { need: need.gel + need.gran, have: totalHave, plants: plants, shortfall: shortfall, packs: d.packs, lead: lead,
      plan: items.length ? { items: items, text: parts.join(' + '), cost: cost, grams: got, n: items.reduce(function (a, i) { return a + i.quantity; }, 0) } : null };
  }

  var pending = null;
  function refresh() {
    var cards = document.querySelectorAll('[data-gl-rg-card]');
    if (!cards.length) return Promise.resolve();
    if (pending) return pending;
    var d = data();
    pending = fetch(cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      var state = compute(cart, d);
      document.querySelectorAll('[data-gl-rg-card]').forEach(function (c) { apply(c, state); });
      pending = null;
    }).catch(function () { pending = null; });
    return pending;
  }

  window.glRootgrow = { refresh: refresh, plan: plan, compute: compute, data: data };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  if (window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 50); });
})();
